import styles from './style.postcss';

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';

import { connect, ApiResponseHelper } from 'omni-common-ui';
import { actions as ketExamsActions,
  accessors as ketExamsAccessors,
  KET_EXAM_TYPE_MOCK,
  KET_EXAM_TYPE_REAL } from 'data/KetExams';

export const MOCK_EXAM_COUNT = 2;
export const DEFAULT_MOCK_INDEX = '1';

export class KetExam extends Component {
  componentWillMount() {
    this._load(this.props);
  }

  componentWillReceiveProps(nextProps) {
    this._load(nextProps);
  }

  _load(props) {
    const { groupId } = props.params;
    props.fetchKetExamsPlanIfNeeded(groupId);

    const { currentExamPlan, exam } = props;
    if (currentExamPlan && ApiResponseHelper.shouldFetch(exam)) {
      props.fetchKetExam(groupId, currentExamPlan.get('ketExamId'));
    }

    if (props.examType === KET_EXAM_TYPE_REAL) {
      (props.mockExams || []).forEach((mockExam) => {
        if (mockExam.ketExamId && ApiResponseHelper.shouldFetch(mockExam.exam)) {
          props.fetchKetExam(groupId, mockExam.ketExamId);
        }
      });
    }
  }

  render() {
    const { examType, children, currentExamPlan, exam, mockExams } = this.props;
    return <div className={styles.KetExam}>
      <div className={styles.KetExam_content}>
        {children && React.cloneElement(children, {
          examType,
          currentExamPlan,
          exam,
          mockExams,
        })}
      </div>
    </div>;
  }
}

KetExam.propTypes = {
  children: PropTypes.node,
  params: PropTypes.object.isRequired,
  examType: PropTypes.string.isRequired,
  currentExamPlan: PropTypes.object,
  exam: PropTypes.object,
  mockExams: PropTypes.array,
  fetchKetExamsPlanIfNeeded: PropTypes.func.isRequired,
  fetchKetExam: PropTypes.func.isRequired,
};

export function mapStateToProps(state, ownProps) {
  const { groupId, mockIndex: mockIndexParam } = ownProps.params;
  const examType = ownProps.route.examType;
  const mockIndex = examType === KET_EXAM_TYPE_MOCK ?
    (mockIndexParam || DEFAULT_MOCK_INDEX) :
    undefined;
  const currentExamPlan =
    ketExamsAccessors.getKetExamPlanByType(state, groupId, examType, mockIndex);
  const exam = currentExamPlan &&
    ketExamsAccessors.getKetExam(state, `${currentExamPlan.get('ketExamId')}`);

  let mockExams;
  if (examType === KET_EXAM_TYPE_REAL) {
    mockExams = [];
    for (let index = 1; index <= MOCK_EXAM_COUNT; index += 1) {
      const mockPlan = ketExamsAccessors.getKetExamPlanByType(
        state, groupId, KET_EXAM_TYPE_MOCK, `${index}`);
      const ketExamId = mockPlan && `${mockPlan.get('ketExamId')}`;
      mockExams.push({
        mockIndex: index,
        ketExamId,
        exam: ketExamId && ketExamsAccessors.getKetExam(state, ketExamId),
      });
    }
  }

  return {
    examType,
    mockIndex,
    currentExamPlan,
    exam,
    mockExams,
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(ketExamsActions, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(KetExam);



// WEBPACK FOOTER //
// ./containers/Group/KetExam/component.jsx